import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=b25a6c22&"
import script from "./SimpleTable.vue?vue&type=script&lang=ts&"
export * from "./SimpleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports